/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionMetadataData
 */
export interface PermissionMetadataData {
    /**
     * 
     * @type {boolean}
     * @memberof PermissionMetadataData
     */
    fieldLevel?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PermissionMetadataData
     */
    permission?: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionMetadataData
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionMetadataData
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionMetadataData
     */
    resourceType?: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionMetadataData
     */
    operation?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PermissionMetadataData
     */
    capabilities?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PermissionMetadataData
     */
    dependencies?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PermissionMetadataData
     */
    businessContext?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionMetadataData
     */
    isFieldLevel?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PermissionMetadataData
     */
    applicableFields?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PermissionMetadataData
     */
    riskLevel?: string;
}

/**
 * Check if a given object implements the PermissionMetadataData interface.
 */
export function instanceOfPermissionMetadataData(value: object): value is PermissionMetadataData {
    return true;
}

export function PermissionMetadataDataFromJSON(json: any): PermissionMetadataData {
    return PermissionMetadataDataFromJSONTyped(json, false);
}

export function PermissionMetadataDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionMetadataData {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldLevel': json['fieldLevel'] == null ? undefined : json['fieldLevel'],
        'permission': json['permission'] == null ? undefined : json['permission'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': json['category'] == null ? undefined : json['category'],
        'resourceType': json['resource_type'] == null ? undefined : json['resource_type'],
        'operation': json['operation'] == null ? undefined : json['operation'],
        'capabilities': json['capabilities'] == null ? undefined : json['capabilities'],
        'dependencies': json['dependencies'] == null ? undefined : json['dependencies'],
        'businessContext': json['business_context'] == null ? undefined : json['business_context'],
        'isFieldLevel': json['is_field_level'] == null ? undefined : json['is_field_level'],
        'applicableFields': json['applicable_fields'] == null ? undefined : json['applicable_fields'],
        'riskLevel': json['risk_level'] == null ? undefined : json['risk_level'],
    };
}

export function PermissionMetadataDataToJSON(json: any): PermissionMetadataData {
    return PermissionMetadataDataToJSONTyped(json, false);
}

export function PermissionMetadataDataToJSONTyped(value?: PermissionMetadataData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fieldLevel': value['fieldLevel'],
        'permission': value['permission'],
        'description': value['description'],
        'category': value['category'],
        'resource_type': value['resourceType'],
        'operation': value['operation'],
        'capabilities': value['capabilities'],
        'dependencies': value['dependencies'],
        'business_context': value['businessContext'],
        'is_field_level': value['isFieldLevel'],
        'applicable_fields': value['applicableFields'],
        'risk_level': value['riskLevel'],
    };
}

